import Menu from "./Menu";

export default Menu


// WEBPACK FOOTER //
// ./src/view/component/menu/index.js